export default function Card({ children, className = "", title, action }) {
  return (
    <div className={`bg-white dark:bg-[var(--bg-surface)] rounded-xl border border-gray-100 dark:border-[var(--border-soft)] shadow-card ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between px-5 pt-4 pb-3">
          {title && <h3 className="font-display font-semibold text-sm text-brand-ink dark:text-[var(--text-primary)]">{title}</h3>}
          {action}
        </div>
      )}
      <div className={title || action ? "px-5 pb-5" : "p-5"}>{children}</div>
    </div>
  );
}